import Api from './api';

const SaudeService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/saude/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/restrito/saude/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    saudeEdit: async (id) => {
        const response = await Api.get(`/restrito/saude/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/saude/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/saude/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    cadastroDocumentos: async (params) => {
        const response = await Api.post('/restrito/docsaude/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listarDocumentos: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/docsaude/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletarDocumentos: (id) => {
        Api.delete(`/restrito/docsaude/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    saudeEditDocumentos: async (id) => {
        const response = await Api.get(`/restrito/docsaude/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editarDocumentos: async (id, params) => {
        const response = await Api.put(`/restrito/docsaude/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscarDocumentos: (params) => {
        const response = Api.get(`/restrito/docsaude/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    cadastroProfissionais: async (params) => {
        const response = await Api.post('/restrito/profsaude/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listarProfissionais: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/profsaude/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletarProfissionais: (id) => {
        Api.delete(`/restrito/profsaude/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    saudeEditProfissionais: async (id) => {
        const response = await Api.get(`/restrito/profsaude/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editarProfissionais: async (id, params) => {
        const response = await Api.put(`/restrito/profsaude/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscarProfissionais: (params) => {
        const response = Api.get(`/restrito/profsaude/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    locais: async (id, params) => {
        const response = await Api.put(`/restrito/profsaude/locais/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    deletarLocal: async (id, params) => {
        const response = await Api.put(`/restrito/profsaude/dellocal/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    cadastroRemume: async (params) => {
        const response = await Api.post('/restrito/remume/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listarRemume: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/remume/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletarRemume: (id) => {
        Api.delete(`/restrito/remume/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    saudeEditRemume: async (id) => {
        const response = await Api.get(`/restrito/remume/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editarRemume: async (id, params) => {
        const response = await Api.put(`/restrito/remume/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscarRemume: (params) => {
        const response = Api.get(`/restrito/remume/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default SaudeService;